import { WS_SHIFTS, WS_WEEKS } from '@pages/WorkSchedule/constants/filters';

import { days } from '@pages/WorkSchedule/data';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import { createFewDates } from '../createFewDates';
import { getDayName } from '../getDayName';

export const getDatesByPattern: NWorkSchedule.GetDatesByPattern = ({
  mode,
  pattern,
  startDate,
}) => {
  const { weeksCount } = pattern;
  let result: string[] = [];

  // ШАГ 1. Получить ID месяца

  // ШАГ 2. Сгенерировать список дат на основе интервала дат
  const datesList: string[] = createFewDates(startDate, 7 * weeksCount);

  // ШАГ 3. Ограничить список дат пользовательским интервалом
  const daysMax = 7 * weeksCount;
  const daysWithUserRange = datesList.slice(0, daysMax);

  if (mode === WS_SHIFTS && pattern.hasOwnProperty('daysCount')) {
    const { daysCount, spaceInDays } = pattern as NWorkSchedule.Shifts;

    // ШАГ 4.1. Учесть паттерн в диапазоне дат
    const datesWithoutSpaces: string[] = [];
    let datesCount = 0;
    let spacesCount = 0; // Под space подразумеваются даты без графиков

    (daysWithUserRange || []).forEach((dateStr: string) => {
      datesCount++;

      if (datesCount <= daysCount && spacesCount === 0) {
        spacesCount = 0;
        return datesWithoutSpaces.push(dateStr);
      } else {
        datesCount = 0;
        spacesCount++;

        if (spacesCount < spaceInDays) {
          // Ничего не возвращаем (даты без графиков)
          return;
        } else {
          return (spacesCount = 0);
        }
      }
    });

    // ШАГ 5.1. Сохранить результат
    result = datesWithoutSpaces;
  } else if (mode === WS_WEEKS && pattern.hasOwnProperty('specificDays')) {
    const { specificDays } = pattern as NWorkSchedule.Weeks;

    // ШАГ 4.2. Учесть паттерн в диапазоне дат
    const datesWithoutSpaces: string[] = [];

    (daysWithUserRange || []).forEach((dateStr: string) => {
      return (specificDays || []).forEach((dayHumanId: NWorkSchedule.Day) => {
        const dayTitle = getDayName(dateStr);
        const _dayHumanId = days.find(
          ({ title }) => title === dayTitle
        )?.humanId;
        const isSelectedDay = _dayHumanId === dayHumanId;

        if (isSelectedDay) {
          return datesWithoutSpaces.push(dateStr);
        }
      });
    });

    // ШАГ 5.2. Сохранить результат
    result = datesWithoutSpaces;
  }

  return result;
};
